import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"

const BetterDocConsentAdditionalInformation = () => {
  const { t } = useTranslation()

  return (
    <div className="max-w-93" data-testid="consent-additional-information">
      <Banner variant="info" className="flex items-start rounded-md px-4 pt-2">
        <div className="text-on-surface grid gap-4">
          <p>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.title")}</p>
          <div>
            <p>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.personalData")}</p>
            <ul className="list-disc pl-5">
              <li>
                {t("episodeOfCare.betterDoc.searchDialog.additionalInformation.personalDataItems.firstNameSurname")}
              </li>
              <li>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.personalDataItems.dateOfBirth")}</li>
              <li>
                {t("episodeOfCare.betterDoc.searchDialog.additionalInformation.personalDataItems.addressDetails")}
              </li>
              <li>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.personalDataItems.phoneNumber")}</li>
              <li>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.personalDataItems.emailAddress")}</li>
              <li>
                {t(
                  "episodeOfCare.betterDoc.searchDialog.additionalInformation.personalDataItems.healthInsuranceCompany",
                )}
              </li>
              <li>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.personalDataItems.language")}</li>
            </ul>
          </div>
          <div>
            <p>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.healthData")}</p>
            <ul className="list-disc pl-5">
              <li>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.healthDataItems.diagnosisCode")}</li>
              <li>{t("episodeOfCare.betterDoc.searchDialog.additionalInformation.healthDataItems.anamnesis")}</li>
              <li>
                {t("episodeOfCare.betterDoc.searchDialog.additionalInformation.healthDataItems.desiredSpecialty")}
              </li>
              <li>
                {t("episodeOfCare.betterDoc.searchDialog.additionalInformation.healthDataItems.reasonForConsultation")}
              </li>
              <li>
                {t("episodeOfCare.betterDoc.searchDialog.additionalInformation.healthDataItems.previousCareProvider")}
              </li>
            </ul>
          </div>
        </div>
      </Banner>
    </div>
  )
}

export { BetterDocConsentAdditionalInformation }
